export const ANALYSIS_COLORED_BOX_VARIANTS = {
  NECESSARY_CONDITION: "necessary-condition",
  TARGET_LEVEL: "target-level",
  LEVEL_OF_NEGATION: "level-of-negation"
};
